module.exports = __webpack_public_path__ + "8406cbd5e55f0cc4e3967d82e9b0f866.pdf";